/* eslint-disable */

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
    Dialog,
    DialogContent,
    DialogHeader,
} from '../ui/dialog'
import {
    Sheet,
    SheetContent,
    SheetHeader,
} from '../ui/sheet'
import { Button } from '../ui/button'
import badge from '../../assets/images/badge.png'
import account_balance from '../../assets/images/account_balance.png'
import edit_document from '../../assets/images/edit_document.png'

const KYC_DOCUMENTS = [
    {
        icon: badge,
        alt: 'pan-card-image',
        title: 'PAN Card',
        description: 'PAN number and date of birth (as on PAN)',
    },
    {
        icon: account_balance,
        alt: 'account-balance-image',
        title: 'Bank Details',
        description: 'Bank account number and IFSC code',
    },
    {
        icon: edit_document,
        alt: 'nominee-details-image',
        title: 'Nominee Details',
        description: 'Nominee PAN, date of birth, email, and mobile number',
    },
]

const KycPopupContent = ({ onRemindLater, onCompleteKyc }) => (
    <div className='flex w-full flex-col items-center'>
        {/* <span className='inline-block rounded-full border-[12px] border-[#FFEDED] bg-[#FF6666] px-3 py-0.5 text-center'>
            <i className='fa-solid fa-exclamation text-white' />
        </span> */}

        <h2 className='mt-4 mb-2 text-center text-xl font-semibold leading-7 text-[#2D2D2D]'>
            Complete your KYC to proceed
        </h2>

        <p className='mb-4 text-center text-base font-normal leading-6 text-[#575757]'>
            Keep the following details handy before you proceed.
        </p>

        <div className='w-full rounded-2xl border border-[#D3DBEC]'>
            {KYC_DOCUMENTS.map((doc, index) => (
                <div
                    key={doc.title}
                    className={`flex items-start gap-2 px-4 py-2 ${index < KYC_DOCUMENTS.length - 1 ? 'border-b border-[#D3DBEC]' : ''
                        }`}
                >
                    <img src={doc.icon} alt={doc.alt} className='h-7 w-7 shrink-0' />
                    <div className='text-left'>
                        <p className='text-base font-medium leading-6'>{doc.title}</p>
                        <p className='text-sm font-normal leading-5'>{doc.description}</p>
                    </div>
                </div>
            ))}
        </div>

        <p className='mt-4 text-center text-base font-DMSans text-black-500'>
            Need help? Reach out at{' '}
            <span className='font-semibold text-primary-500'>+91-8050034800</span>.
        </p>

        <div className='mt-6 flex w-full flex-col justify-center gap-2 sm:flex-row'>
            {/* <Button
                variant='outline'
                onClick={onRemindLater}
                className='rounded-lg px-6 py-2.5 text-sm font-medium'
            >
                Remind me later
            </Button> */}
            <Button onClick={onCompleteKyc} className='rounded-lg px-6 py-2.5 text-sm font-medium'>
                Continue
            </Button>
        </div>
    </div>
)

const KycPopup = ({ open, onClose }) => {
    const navigate = useNavigate()
    const [isMobile, setIsMobile] = useState(() =>
        typeof window !== 'undefined' ? window.innerWidth < 768 : null,
    )

    useEffect(() => {
        const checkIfMobile = () => setIsMobile(window.innerWidth < 768)
        checkIfMobile()
        window.addEventListener('resize', checkIfMobile)
        return () => window.removeEventListener('resize', checkIfMobile)
    }, [])

    const handleRemindLater = () => onClose()
    const handleCompleteKyc = () => {
        onClose()
        navigate('/dashboard/start-kyc')
    }

    // Avoid flashing the wrong variant while viewport is unknown
    if (isMobile === null) return null

    if (isMobile) {
        return (
            <Sheet open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
                <SheetContent side='bottom' className='max-h-[90vh] overflow-y-auto rounded-t-3xl font-DMSans'>
                    <SheetHeader className='text-left'>
                        <KycPopupContent onRemindLater={handleRemindLater} onCompleteKyc={handleCompleteKyc} />
                    </SheetHeader>
                </SheetContent>
            </Sheet>
        )
    }

    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <DialogContent className='max-h-[90vh] max-w-[550px] overflow-y-auto font-DMSans'>
                <DialogHeader>
                    <KycPopupContent onRemindLater={handleRemindLater} onCompleteKyc={handleCompleteKyc} />
                </DialogHeader>
            </DialogContent>
        </Dialog>
    )
}

export default KycPopup
